import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetMailingList = {
  getMailingList: { data: null, loading: false, error: null },
};

export const getMailingList = createAsyncThunk('user/getMailingList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/mailing`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetMailingList = {
  [getMailingList.pending]: (state) => {
    // state.getMailingList.data = null;
    state.getMailingList.loading = true;
    state.getMailingList.error = null;
  },
  [getMailingList.fulfilled]: (state, action) => {
    state.getMailingList.loading = false;
    state.getMailingList.data = action.payload;
    state.getMailingList.error = null;
  },
  [getMailingList.rejected]: (state, action) => {
    state.getMailingList.loading = false;
    state.getMailingList.error = action.payload;
  },
};
